/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/angular-fullscreen/angular-fullscreen.d.ts" />

namespace Application.Controllers {
    'use strict';
    import IFlexSection = Models.IFlexSection;
    import FlexSections = Models.FlexSections;
    import IAuthority = Application.Models.IAuthority;
    import Utils = Application.Common.Utils;
    import SonAdapterService = Application.Services.SonAdapterService;


    interface IAdminSettings {
        url: string;
    }

    interface IWindowWithBuildVersionInfo extends Window {
        versionInfo: {
            branch: string;
            commit: string;
            buildDate: string;
            version: string;
        };
    }
    interface ICanSeeSections {
        canSeeMatrixRoom: boolean;
        canSeeAlarmsConsole: boolean;
        canSeeSystemAlarms: boolean;
    }

    /**
     * MainController class
     */
    export class MainController {
        public static $name: string = "mainController";
        public static $inject: string[] = ['$rootScope',
                                           '$location',
                                           'loginService',
                                           '$scope',
                                           "$cookies",
                                           '$timeout',
                                           '$q',
                                           'userService',
                                           'timezoneService',
                                           'ModalService',
                                           'Fullscreen',
                                           'aclService',
                                           'backendService',
                                           'miniSidebarService',
                                           'notificationService',
                                           'connectionRoomService',
                                           '$interval',
                                           'navigationHistoryService',
                                           'backendConfigService',
                                           'stompService',
                                           'vnoService',
                                            '$window'
                                        ];

        public static COOKIE_OPTIONS: ng.cookies.ICookiesOptions =
                    { expires: Common.Utils.getCookieExpirationDate(), secure:  location.protocol === 'https:'  };
        private static userTimezoneCookieKey: string = "flex_user_timezone";
        private static userTimezoneOptionCookieKey: string = "flex_user_timezone_option";
        private static miniSidebarActiveCookieKey: string = "minisidebar_active";
        private static connectionLockCookieKey: string = "connection_locked";
        private static PING_HEALTH_TIMER: number = 60000;

        public isBackendPresent: boolean;
        public isErrorMessagePresent: boolean;
        public adminSectionsMode: boolean;
        public connectionLocked: boolean;
        public flexSections: IFlexSection[] = [];
        public vnoLogo: string = undefined;
        public canSeeAdminDocs: boolean = false;
        public canSeeCommissioningDocs: boolean = false;
        public canSeeSections: ICanSeeSections;
        public hasDigicon: boolean = false;

        // general settings
        public versionInfo: Object;

        public timezones: Models.ITimezone[];
        public selectedTimezone: Models.ITimezone;
        public admin: IAdminSettings = {url: ''};

        private pingTimeout: ng.IPromise<void>;

        private watchers: Function[] = [];
        private flexSectionsObject: FlexSections;
        private stompWatchers: Services.IEventSubscription[] = [];

        /**
         * Constructor
         */
        constructor(private $rootScope: IFlexRootScope,
                    private $location: ng.ILocationService,
                    private loginService: Services.LoginService,
                    private $scope: ng.IScope,
                    private $cookies: ng.cookies.ICookiesService,
                    private $timeout: ng.ITimeoutService,
                    private qService: ng.IQService,
                    private userService: Services.UserService,
                    private timezoneService: Services.TimezoneService,
                    private modalService: ngModal.IModalService,
                    private fBAngular: FBAngular.IFullScreen,
                    private aclAservice: Services.AclService,
                    private backendService: Services.BackendService,
                    private miniSidebarService: Services.MiniSidebarService,
                    private notificationService: Services.NotificationService,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private $interval: ng.IIntervalService,
                    private navigationHistoryService: Services.NavigationHistoryService,
                    private backendConfigService: Services.BackendConfigService,
                    private stompService: Services.StompService,
                    private vnoService: Services.VnoService,
                    private $window: Window) {

            this.adminSectionsMode = false;
            this.isBackendPresent = true;
            this.isErrorMessagePresent = false;
            this.canSeeSections = {
                canSeeMatrixRoom: false,
                canSeeAlarmsConsole: false,
                canSeeSystemAlarms: false,
            };

            this.$rootScope.vars = {
                isUserLoggedIn: false,
                connectionLocked: false,
            };

            angular.element($window).on('webkitfullscreenchange  mozfullscreenchange fullscreenchange', (event)=> {
                 if ($rootScope.kiosk  && (document.webkitIsFullScreen === false || document['mozFullScreen'] === false)) {
                        this.toggleKioskMode(false);
                    }

            });

            this.backendConfigService.isServiceAvailable(SonAdapterService.SERVICE_NAME).then((isServiceAvailable: boolean) => {
                this.$rootScope.hasSon = isServiceAvailable;
            });

            this.backendConfigService.isMonitoringOnlyInstance().then((isMonitoringOnly: boolean) => {
                this.$rootScope.isMonitoringOnly = isMonitoringOnly;
            });

            this.backendConfigService.isMaintenance().then((isMaintenance: boolean) => {
                this.$rootScope.isMaintenance = isMaintenance;
            });

            this.initWatchers();
            // TODO: When websso is merged, fetch this using the BackendConfigService and a request to /systemConfigs
            this.$rootScope.backendConfig = {
                systemAlarmsVisible: true,
                flexoProxyType: 'PORT_BASED',
            };

            let versionInfo: string = 'versionInfo';
            if (window[versionInfo]) this.versionInfo = window[versionInfo];
            this.checkDigicon();
        }

        public getCurrentUser(): Models.User {
            return this.userService.getCurrentUser();
        }

        public isImpersonated(): boolean {
            return this.userService.getCurrentUser().authorities.filter((authority: IAuthority) => authority.authority === "ROLE_PREVIOUS_ADMINISTRATOR")[0] !== undefined;
        }

        public endImpersonateUser(): void {
            this.userService.endImpersonateUser();
        }


        public toggleSidebarMini(visible?: boolean): void {
            this.miniSidebarService.toggleSidebarMini(visible);
        }

        public toggleFullScreen(): void {
            this.fBAngular.all();
        }

        public toggleKioskMode(toggle: boolean): void {
            if (toggle) {
                this.$location.search('kiosk', 'true');
            }
            else {
                this.$location.search('kiosk', null);
            }
            if (toggle && (document.webkitIsFullScreen === false || document['mozFullScreen'] === false)) { //mozilla and chrome support
                this.fBAngular.toggleAll();
            }
            this.$rootScope.kiosk = toggle;
            this.$rootScope.$emit("$routeChangeSuccess");

        }

        public goBack(): void {
            this.navigationHistoryService.goBack();
        }

        public pageHasHistory(): boolean {
            return this.navigationHistoryService.getSizeOfHistory() > 1;
        }

        public getClass(path: string): boolean {
            this.adminSectionsMode = (this.$location.path().indexOf('/admin') !== -1);
            if (path === '/topology-manager') {
                // sections with subsections
                return this.getClass('/network-nodes') || this.getClass('/network-map');
            } else if (path === "/mobile-data") {
                // sections with subsections
                return this.getClass('/mobile-devices') || this.getClass('/sims') || this.getClass('/sim-plans');
            } else {
                return (this.$location.path().substr(0, path.length) === path);
            }
        }

        public getClassForSubsection (path: string): boolean {
            return (this.$location.path().substr(0, path.length) === path);
        }

        public getIdByHref(href: string): number {
            let id: string = href.substr(href.lastIndexOf('/') + 1);
            return parseInt(id, 10);
        }

        // TODO: avoid using methods in directives
        public isRegularVnoUser(): boolean {
            return this.userService.userIsRegularVnoUser();
        }

        /**
         * Helper function used to generates the array that will be used to generate the pagination numbers
         * @param {number} max - The number of the last page (index origin = 1).
         */
        public range(max: number): number[] {
            return new Array(max);
        }

        public logout(): void {
            this.loginService.logout();
        }

        public launchAboutModal(): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.AboutModalController.templateURL,
                controller: Application.Controllers.AboutModalController.$name,
                inputs: {buildInfo: this.getBuildVersionInfoObject(),
                        },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.AboutModalController.ID,
                                                                {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    modalElem.hide();
                });
            });
        }

        public showView(): boolean {
            return this.$rootScope.vars.isUserLoggedIn === true || this.$location.path().indexOf('/login') !== -1;
        }

        public getFlattenedFlexSections(): IFlexSection[] {
            let flat: IFlexSection[] = [];
            this.flexSections.forEach((section: IFlexSection) => {
                if (((this.adminSectionsMode && section.adminSection) ||
                     (!this.adminSectionsMode && !section.adminSection))) {
                    if (section.subsections === undefined || section.subsections.length === 0) {
                        flat.push(section);
                    } else {
                        section.subsections.forEach((subsection: IFlexSection) => {
                            flat.push(subsection);
                        });
                    }
                }
            });
            return flat;
        }

        public getBuildVersionInfo(): string {
            // versionInfo is defined in plugins/docker/util.js
            // it is added by the docker image on launch, if the image was built with --changelog
            let w: IWindowWithBuildVersionInfo = window as IWindowWithBuildVersionInfo;
            if (w.versionInfo) {
                return `${w.versionInfo.branch}
                        build ${w.versionInfo.commit}
                        (${w.versionInfo.buildDate})
                        <a href="changelog.html">changelog</a>`;
            } else {
                return undefined;
            }
        }

        public getBuildVersionInfoObject(): Object {
            let w: IWindowWithBuildVersionInfo = window as IWindowWithBuildVersionInfo;
            if (w.versionInfo) {
                return w.versionInfo;
            } else {
                return undefined;
            }
        }

        public menuSectionMouseover(id: string, miniAndSubsections: boolean): void {
            if (miniAndSubsections) {
                let parent: JQuery = $('#' + id);
                let parentOffset: { top: number, left: number} = parent.offset();
                let parentHeight: number = parent.height();
                let scroll: number = $(document).scrollTop();
                $('.sidebar_submenu .menu_title').css('top', parentOffset.top - parentHeight - scroll + 'px');
                $('.sidebar_submenu ul').css('top', parentOffset.top - scroll + 'px');
            }
        }

        /**
         * This is called when the user navigates to other page of the portal (maybe through the side menu)
         * */
        public changeRoute(href: string): void {
            if ( this.$location.path() !== href ) {
                if (this.connectionLocked) {
                    this.connectionRoomService.dropLock();
                    this.connectionLocked = false;
                    this.$cookies.put(MainController.connectionLockCookieKey, "false", MainController.COOKIE_OPTIONS);
                }
            }

            this.$location.path(href);
        }

        private showWebApplication(flexSections: IFlexSection[]): ng.IPromise<IFlexSection[]> {
            const ids: number[] = flexSections.map((flexSection: IFlexSection) => {
                return flexSection.id;
            });
            return this.aclAservice
                .canReadList("io.epiclabs.flex.api.WebApplication", ids)
                .then((can: boolean[] ) => {
                    return flexSections.map((flexSection: IFlexSection, index: number) => {
                        flexSection.canRead = can[index];
                        if (flexSection.subsections)
                            flexSection.subsections.forEach((subsection: IFlexSection) => {
                                subsection.canRead = can[index];
                            });
                        return flexSection;

                    });
                });
        }

        private defineFlexSections(): void {

            this.flexSections = [
                {
                    href: '/admin/users',
                    title: 'Users',
                    icon: 'person',
                    adminSection: true,
                    id: 10,
                }, {
                    href: '/admin/vno',
                    title: 'VNOs',
                    icon: 'location_city',
                    adminSection: true,
                    id: 15,
                }, {
                    href: '/admin/alarms',
                    title: 'Alarms',
                    icon: 'notifications',
                    adminSection: true,
                    id: 9,
                    subsections: [{
                        href: '/admin/alarms/templates',
                        title: 'Device templates',
                        icon: 'assignment',
                        adminSection: true,
                    }, {
                        href: '/admin/alarms/specifics',
                        title: 'Device specifics',
                        icon: 'router',
                        adminSection: true,
                    }, {
                        href: '/admin/alarms/services',
                        title: 'Flex services',
                        icon: 'widgets',
                        adminSection: true,
                    }],
                }, {
                    href: '/admin/system',
                    title: 'System',
                    icon: 'build',
                    adminSection: true,
                    id: 20,
                    subsections: [{
                        href: '/admin/system/system-alarms',
                        title: 'System alarms',
                        icon: 'perm_data_setting',
                        adminSection: true,
                    }, {
                        href: '/admin/system/flex-services',
                        title: 'Flex services',
                        icon: 'widgets',
                        adminSection: true,
                    }],
                },
                {
                    href: '/admin/events',
                    title: 'Events',
                    icon: 'event_note',
                    adminSection: true,
                    id: 12,
                },  {
                    href: '/admin/inventory',
                    title: 'Inventory',
                    icon: 'list',
                    adminSection: true,
                    id: 13,
                }, {
                    href: '/admin/multi-blocks',
                    title: 'MultiBlocks',
                    icon: 'dns',
                    adminSection: true,
                    id: 19,
                }, {
                    href: '/admin/message-translation',
                    title: 'Message Translation',
                    icon: 'speaker_notes',
                    adminSection: true,
                    id: 17,
                },  {
                    href: '/admin/bundles',
                    title: 'Bundles',
                    icon: 'format_list_numbered',
                    adminSection: true,
                    id: 22,
                }, {
                    href: '/admin/preset-paths/srt',
                    title: 'Preset Paths',
                    icon: 'low_priority',
                    adminSection: true,
                    id: 23,
                },
                {
                    href: '/admin/redundant-blocks',
                    title: 'Redundant Blocks',
                    icon: 'done_all',
                    adminSection: true,
                    id: 23,
                },
                {
                    href: '/multiviewer',
                    title: 'Multiviewer room',
                    icon: 'featured_video',
                    adminSection: false,
                    id: 14,
                },
                {
                    href: '/digicon-viewer',
                    title: 'Digicon Viewer',
                    icon: 'kitchen',
                    adminSection: false,
                    id: 14,
                },
                {
                    href: '/monitoring-room',
                    title: 'Monitoring room',
                    icon: 'tv',
                    id: 1,
                },
                {
                    href: '/matrix-room',
                    title: 'Matrix room',
                    icon: 'view_module',
                    id: 2,
                    demiurgoOnly: this.$rootScope.isMonitoringOnly,
                }, {
                    href: '/connection-room',
                    title: 'Connection room',
                    icon: 'settings_input_component',
                    id: 8,
                }, {
                    href: '/network-map',
                    title: 'Network map',
                    icon: 'device_hub',
                    id: 3,
                }, {
                    href: '/network-nodes',
                    title: 'Support Toolkit',   // Originally called 'Network Nodes', this is prone to create confusion.
                    icon: 'build',
                    id: 4,
                },
                {
                    href: '/ts-probes',
                    title: 'TS Probes',
                    icon: '',
                    classes: 'nm-flex-eurovision-icon eurovision-icon epic24 eurovision-radio-waves',
                    adminSection: false,
                    id: 18,
                },
                {
                    href: '/alarm-console',
                    title: 'Alarms Console',
                    icon: '',
                    adminSection: false,
                    id: 21,
                },
            ];
            // TODO: check if user belongs to multiple VNOs to avoid logo retrieval
            this.vnoService.getVnoLogo(this.getCurrentUser().organizationId).then((logo: string) => {
                this.vnoLogo = logo;
            });

            this.showWebApplication(this.flexSections).then((res: IFlexSection[]) => {
                // If the user is only Organization Admin is not allowed to see the network map tab
                this.$rootScope.isRoleAdmin = this.isRoleAdmin();
                this.flexSections = this.hasDigicon ? res : this.removeSectionByTitle(res, 'Digicon Viewer');
                this.flexSectionsObject = new FlexSections(this.flexSections);
                this.$rootScope.flexSections = this.flexSectionsObject;
                this.admin.url = this.flexSectionsObject.getFirstAdminSectionHref();
                this.flexSectionsObject.enforceReadableSection(this.$location);
                this.canSeeSections = {
                    canSeeMatrixRoom: this.flexSectionsObject.getSectionWithId(2).canRead,
                    canSeeAlarmsConsole: this.flexSectionsObject.getSectionWithId(21).canRead,
                    canSeeSystemAlarms: this.$rootScope.backendConfig.systemAlarmsVisible &&
                        this.flexSectionsObject.getSectionWithId(20).canRead,
                };
            });
        }

        /**
         * Method to check if a user is "Role Admin"
         */
        private isRoleAdmin(): boolean {
            let isRoleAdmin: boolean = false;
            const authorities: IAuthority[] = this.getCurrentUser().authorities;

            for (const authority of authorities) {
                if (authority.authority === "ROLE_ADMIN") {
                    return true;
                }
            }

            return false;
        }

        /**
         * Method to remove a section available from a User by section title
         * @param sections array with all the sections to be filtered
         * @param sectionTitle title of the section to be removed
         * @return the array filtered
         */
        private removeSectionByTitle(sections: IFlexSection[], sectionTitle: string): IFlexSection[] {
            return sections.filter(function( section: IFlexSection ) {
                return section.title !== sectionTitle;
            });
        }

        private initWatchers(): void {
            this.$scope.$on('$destroy', () => {
                this.watchers.forEach((watcher: Function) => watcher());
                for (const stompWatcher of this.stompWatchers) {
                    this.stompService.unregister(stompWatcher);
                }
                if (this.pingTimeout !== undefined)
                    this.$interval.cancel(this.pingTimeout);
            });

            this.watchers.push(this.initIsBackendPresentListener());
            this.watchers.push(this.initIsErrorMessagePresentListener());
            this.watchers.push(this.initDropLockListener());
            this.watchers.push(this.initIsUserLoggedInListener());
            this.watchers.push(this.initMiniSidebar());
            this.watchers = this.watchers.concat(this.initTimezoneFeatures());
            
            this.stompWatchers.push(
                this.stompService.register(Models.FLEXAUTH_COMPONENT, Models.USER_PERMISSIONS_MODIFIED,
                    (flexEvent: Models.IFlexEvent) => {
                        this.refreshUserAfterPermissionsChanged(flexEvent);
                    })
            );
        }

        private refreshUserAfterPermissionsChanged(flexEvent: Application.Models.IFlexEvent): void {
            if (this.getCurrentUser().id === Number(flexEvent.userId)) {
                this.userService.loadCurrentUser(true).then(() => {
                    this.defineFlexSections();
                    if (this.pingTimeout !== undefined)
                        this.$interval.cancel(this.pingTimeout);
                    this.pingHealth();
                    this.$location.path('/');
                    Common.Utils.alertOnInfo('Your permissions have been modified.', 'bottom-center');
                }).catch(() => {
                    this.logout();
                    Common.Utils.alertOnError('Your permissions have been modified. Please do log-in again.', 'bottom-center');
                });
            }
        }

        private initIsBackendPresentListener(): Function {
            return this.$scope.$on('isBackendPresent', (event: ng.IAngularEvent, args: boolean) => {
                this.isBackendPresent = args;
            });
        }

        private initIsErrorMessagePresentListener(): Function {
            return this.$scope.$on('isErrorMessagePresent', (event: ng.IAngularEvent, args: boolean) => {
                this.isErrorMessagePresent = args;
                    setTimeout(() => {
                        this.isErrorMessagePresent = false;
                        // And any other code that should run only after 3s
                    }, 3000);
            });
        }

        private initDropLockListener(): Function {
            let connectionLockCookie: string = this.$cookies.get(MainController.connectionLockCookieKey);
            if (connectionLockCookie) {
                this.connectionLocked = connectionLockCookie === 'true';
            }

            return this.$scope.$on('vars.connectionLocked', (event: ng.IAngularEvent, args: boolean) => {
                this.connectionLocked = args;
                this.$cookies.put(MainController.connectionLockCookieKey, "" + args, MainController.COOKIE_OPTIONS);
            });
        }

        private initIsUserLoggedInListener(): Function {
            return this.$rootScope.$watch('vars.isUserLoggedIn', (newVal: boolean, oldVal: boolean) => {
                this.$timeout(() => {
                    if (newVal !== oldVal) {
                        if (newVal) {
                            this.userService.loadCurrentUser(true).then(() => {
                                this.defineFlexSections();
                                if (this.pingTimeout !== undefined)
                                    this.$interval.cancel(this.pingTimeout);
                                this.pingHealth();
                                this.calculateDocsVisibility();
                            });
                        } else {
                            this.userService.unloadCurrentUser();
                            if (this.pingTimeout !== undefined)
                                this.$interval.cancel(this.pingTimeout);
                            this.hideDocs();
                        }
                    }
                });
            });
        }

        private async calculateDocsVisibility(): Promise<void> {
            this.canSeeCommissioningDocs = await this.userService.userHasRolePromise('ROLE_ADMIN');
            this.canSeeAdminDocs = await this.userService.userHasRolePromise('ORG_ADMIN') || this.canSeeCommissioningDocs;
        }

        private async checkDigicon(): Promise<void> {
            await this.backendConfigService.hasDigicon().then((hasDigicon) => this.hasDigicon = hasDigicon);
        }

        private hideDocs(): void {
            this.canSeeCommissioningDocs = false;
            this.canSeeAdminDocs = false;
        }

        private initMiniSidebar(): Function {
            let miniSidebarCookie: string = this.$cookies.get(MainController.miniSidebarActiveCookieKey);

            if (miniSidebarCookie !== undefined) {
                this.$rootScope.miniSidebarActive = miniSidebarCookie === 'true';
            }
            return this.$rootScope.$watch('largeScreen', (newVal: boolean, oldVal: boolean) => {
                if ((!newVal && !this.$rootScope.miniSidebarActive) || this.$rootScope.kiosk === true) {
                    this.toggleSidebarMini(true);
                } else if (newVal) {
                    let miniSBCookie: string = this.$cookies.get(MainController.miniSidebarActiveCookieKey);
                    if (miniSBCookie !== undefined) {
                        this.toggleSidebarMini(miniSBCookie === 'true');
                    } else {
                        this.toggleSidebarMini(false);
                    }
                }
            });
        }

        private initTimezoneFeatures(): Function[] {
            this.timezones = this.timezoneService.getTimezones();

            if (this.$cookies.get(MainController.userTimezoneCookieKey))
                this.$timeout(() => {
                    this.selectedTimezone = Services.TimezoneService.getTimezoneByText(
                        Common.Utils.escapeHtml(this.$cookies.get(MainController.userTimezoneCookieKey)));
                });
            else
                this.$timeout(() => {
                    this.selectedTimezone = this.timezones[0];
                });

            if (this.$cookies.get(MainController.userTimezoneOptionCookieKey) === this.timezoneService.timezoneOptions[1].value) {
                this.$timeout(() => {
                    this.timezoneService.timezoneOptions[0].selected = false;
                    this.timezoneService.timezoneOptions[1].selected = true;
                    this.timezoneService.timezoneOptions[2].selected = false;
                }, 200);
            } else if (this.$cookies.get(MainController.userTimezoneOptionCookieKey) === this.timezoneService.timezoneOptions[2].value) {
                this.$timeout(() => {
                    this.timezoneService.timezoneOptions[0].selected = false;
                    this.timezoneService.timezoneOptions[1].selected = false;
                    this.timezoneService.timezoneOptions[2].selected = true;
                }, 200);
            } else {
                this.$timeout(() => {
                    this.timezoneService.timezoneOptions[0].selected = true;
                    this.timezoneService.timezoneOptions[1].selected = false;
                    this.timezoneService.timezoneOptions[2].selected = false;
                }, 200);
            }

            const timezoneOptionsWatcher: Function = this.$scope.$watch('mc.timezoneService.timezoneOptions',
                (newValue: EurovisionControl.IRadioOption[], oldValue: EurovisionControl.IRadioOption[]) => {
                    if (newValue !== undefined && newValue !== oldValue) {
                        if (this.timezoneService.timezoneOptions[1].selected) {
                            this.$cookies.put(MainController.userTimezoneOptionCookieKey,
                                this.timezoneService.timezoneOptions[1].value, MainController.COOKIE_OPTIONS);
                        } else if (this.timezoneService.timezoneOptions[2].selected) {
                            if (this.$cookies.get(MainController.userTimezoneCookieKey)) {
                                this.$timeout(() => {
                                    this.selectedTimezone = Services.TimezoneService.getTimezoneByText(
                                        Common.Utils.escapeHtml(this.$cookies.get(MainController.userTimezoneCookieKey)));
                                });
                            } else {
                                // previously selected option was UTC
                                if (oldValue[0].selected) {
                                    let utcTimezone: Models.ITimezone = Services.TimezoneService.getTimezoneByUtc("Etc/GMT");
                                    this.$timeout(() => {
                                        this.selectedTimezone = utcTimezone ? utcTimezone : this.timezones[0];
                                    });
                                    // previously selected option was autodetect
                                } else {
                                    let autoDetectedTimeZoneString: string = moment.tz.guess();
                                    let autoDetectedTimeZone: Models.ITimezone;
                                    autoDetectedTimeZone = Services.TimezoneService.getTimezoneByUtc(autoDetectedTimeZoneString);
                                    this.$timeout(() => {
                                        this.selectedTimezone = autoDetectedTimeZone ? autoDetectedTimeZone : this.timezones[0];
                                    });
                                }
                            }
                            this.$cookies.put(MainController.userTimezoneOptionCookieKey,
                                this.timezoneService.timezoneOptions[2].value, MainController.COOKIE_OPTIONS);
                        } else {
                            this.$cookies.put(MainController.userTimezoneOptionCookieKey,
                                this.timezoneService.timezoneOptions[0].value, MainController.COOKIE_OPTIONS);
                        }
                        if(oldValue !== undefined) //Not first load
                        this.$rootScope.$broadcast('timezoneChanged');
                    }
                }, true);

            const timezoneWatcher: Function = this.$scope.$watch('mc.selectedTimezone',
                (newValue: Models.ITimezone, oldValue: Models.ITimezone) => {
                    if (newValue !== undefined && newValue !== oldValue) {
                        this.timezoneService.setUserTimezone(Services.TimezoneService.getTimezoneByText(newValue.text));
                        this.$cookies.put(MainController.userTimezoneCookieKey, newValue.text, MainController.COOKIE_OPTIONS);
                    }
                    if (oldValue !== undefined) //Not first load
                        this.$rootScope.$broadcast('timezoneChanged');
                });

            return [timezoneOptionsWatcher, timezoneWatcher];
        }

        /**
         * Return the platform of the user
         * @returns 'MAC','WINDOWS','LINUX','UNKNOWN';
         * */
        public getUserPlatform(): string {
                return Utils.getDevicePlatform();
        }

        private pingHealth(): void {
            this.pingTimeout = this.$interval(() => {
                    this.backendService.pingHealth();
            }, MainController.PING_HEALTH_TIMER);
        }
    }
}
